export enum FlowEnum {
	HEALTH = 'HEALTH',
	ODONTO = 'ODONTO',
	EXAM = 'EXAM',
	TELEHEALTH = 'TELEHEALTH',
	PROFILE = 'PROFILE',
	AUTHORIZATIONS = 'AUTHORIZATIONS',
	HEALTH_GUIDE = 'HEALTH_GUIDE',
	ODONTO_GUIDE = 'ODONTO_GUIDE',
	SURGERY = 'SURGERY',
}

type BookingFlowType = Exclude<
	FlowEnum,
	FlowEnum.PROFILE | FlowEnum.AUTHORIZATIONS | FlowEnum.HEALTH_GUIDE | FlowEnum.ODONTO_GUIDE
>;

export type {BookingFlowType};
